module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/4_d78b9bd79d17b5b9bcb7bdbc33428bc9.png";